import { createSlice } from "@reduxjs/toolkit";

// Its own slice rather than folded into palletReview: that slice shares loading
// flags across unrelated thunks, which has already caused in-flight requests to
// clobber each other.
//
// workItemsByReference maps pending VOR reference -> work item summary. The
// mapping-triage list comes from vor-sku-ops and carries no work_item_id, so
// this is how the existing screen knows a SKU is review-backed.
const initialState = {
  workItemsByReference: {},
  workItemsLoading: false,
  submitting: false,
};

const SkuResolutionSlice = createSlice({
  name: "skuResolution",
  initialState,
  reducers: {
    setWorkItems: (state, action) => {
      state.workItemsByReference = action.payload || {};
    },
    setWorkItemsLoading: (state, action) => {
      state.workItemsLoading = action.payload;
    },
    setSubmitting: (state, action) => {
      state.submitting = action.payload;
    },
  },
});

export const { setWorkItems, setWorkItemsLoading, setSubmitting } =
  SkuResolutionSlice.actions;

export default SkuResolutionSlice.reducer;
